import React from 'react';
import {formatDate} from '@pluto/react-select-mapping';
import ConfigPublishedDate from './ConfigPublishedDate';

export default function ConfigPublishedDateContainer(props: any) {
    const {
        isValidDate,
        publishedDateField,
        isPublishedDateShown,
    } = props;
    
    if (!isPublishedDateShown)
        return null;
    
    return (
        <ConfigPublishedDate
            isValidDate={isValidDate}
            publishedDateField={publishedDateField}
            dateValue={formatDate(publishedDateField.input.value)}
        />
    );
}
